import { configureStore } from '@reduxjs/toolkit'
import counterSlice from './actions/counterSlice'
import apiSlice from './actions/apiSlice'
import dashboardTitle from './actions/dashboardTitle'
import userAuthorization from './actions/userAuthorization'
import userTypeSlice from './actions/userTypeSlice'
import procurementDivisionType from './actions/userTypeSlice'
import materialData from './actions/materialData'
import PriceMemoSlice from './actions/PriceMemo'
import DataErrorSlice from './actions/DataErrors'
import moveToDataErrorSlice from './actions/MoveToDataErrors'
import moveToContractSlice from './actions/MoveToContract'
import adminSchedulerSlice from './actions/Admin/AdminScheduler'
import saveAndRunSlide from './actions/Admin/SaveAndRun'
import getAllScheduledJobsSlice from './actions/Admin/AdminScheduler/GetScheduledJobs'
import getJobRunDetailSlice from './actions/Admin/AdminScheduler/JobRunDetails'
import contractSlice from './actions/Contracts'
import resolveSlice from './actions/Resolve'
import saveContractSlice from './actions/SaveContracts'
import sendErrorSlice from './actions/SendEmail'
import ActionDashboardSlice from './actions/LTPlanner/ActionDashboardSlice'
import AnalyticsWorkflowResultsSlice from './actions/LTPlanner/AnalyticsWorkflowResultsSlice';
import SendToS4MaterialsSlice from './actions/LTPlanner/SendToS4MaterialsSlice';
import RejectWorkflowSlice from './actions/LTPlanner/RejectWorkflowSlice';
import SendForApprovalSlice from './actions/LTPlanner/SendForApprovalSlice';
import ReassignToOthersSlice from './actions/LTPlanner/ReassignToOthersSlice';
import ResubmitWorkflowSlice from './actions/LTPlanner/ResubmitWorkflowSlice';
import EditApproversWorkflowSlice from './actions/LTPlanner/EditApproversWorkflowSlice';
import LTPlannerMaterialDropdownDataSlice from './actions/Admin/LTPlannerMaterialDropdownDataSlice';
import GetAllUsers from './actions/Admin/GetAllUsers';
import GetAllGMPUsers from './actions/Admin/GetAllGMPUsers';
import SearchLTPlannerMaterialSlice from './actions/Admin/SearchLTPlannerMaterialSlice';
import SaveLTPlannerMaterialSlice from './actions/Admin/SaveLTPlannerMaterialSlice';
import UpdateLTPlannerEditSlice from './actions/Admin/UpdateLTPlannerEditSlice';
import deleteContractSlice from './actions/DeleteContract';
import ParamConfigDropdownDataSlice from './actions/Admin/ParamConfigDropdownDataSlice';
import ParamConfigSearchMaterialSlice from './actions/Admin/ParamConfigSearchMaterialSlice';
import ParamConfigSaveSlice from './actions/Admin/ParamConfigSaveSlice';
import ParamConfigUpdateSlice from './actions/Admin/ParamConfigUpdateSlice';
import GetWorkflowCountSlice from './actions/Admin/GetWorkflowCountSlice';
import GetApproverResultsSlice from './actions/LTApprover/GetApproverResultsSlice';
import RejectPlannerByApproverSlice from './actions/LTApprover/RejectPlannerByApproverSlice';
import SendToNextLevelSlice from './actions/LTApprover/SendToNextLevelSlice';
import ViewAllLineItemsDataSlice from './actions/ViewAllLineItemsDataSlice';
import jobCancelledSlice from './actions/JobCancelled';
import getAllSourcePriceMemoDataSlice from './actions/GetAllSourcePriceMemo';
import undoDataErrorSlice from './actions/UndoDataError';
import PowerBIMaterialDetailsSlice from './actions/LTPlanner/PowerBIMaterialDetailsSlice';
import PowerBIActionDashboardSlice from './actions/LTPlanner/PowerBIActionDashboardSlice';
import GetHeaderRolesSlice from './actions/HeaderRoles/GetHeaderRolesSlice';
import OutboundResyncSlice from './actions/Admin/OutboundResyncSlice';
import OutboundResolvedSlice from './actions/Admin/OutboundResolvedSlice';
import OutboundDataTableSlice from './actions/Admin/OutboundDataTableSlice';
import submitContractSlice from './actions/SubmitContract';
import getJobInputSlice from './actions/GetJobDetails';
import GetAdminHideColumns from './actions/HideColumns/GetAdminHideColumns';
import GetApproverHideColumns from './actions/HideColumns/GetApproverHideColumns';
import GetPlannerHideColumns from './actions/HideColumns/GetPlannerHideColumns';
import PostAdminHideColumns from './actions/HideColumns/PostAdminHideColumns';
import PostApproverHideColumns from './actions/HideColumns/PostApproverHideColumns';
import PostPlannerHideColumns from './actions/HideColumns/PostPlannerHideColumns';
import ResubmitSlice from './actions/LTApprover/ResubmitSlice';
import GraphPercentile from './actions/GraphPercentile';
import OutboundDataResyncPostAPI from './actions/LTPlanner/OutboundDataResyncPostAPI';
import OutboundDataSyncPlanner from './actions/LTPlanner/OutboundDataSyncPlanner';
import GetPowerBIReportsSlice from './actions/PowerBIReports/GetPowerBIReportsSlice';
import editJobDetailSlice from './actions/EditJobDetails';
import fetchPriceMemoReportSlice from './actions/PriceMemoReport';
import fetchContractReportSlice from './actions/ContractReport';
import reOpenContractSlice from './actions/ContractReport/ReOpen';
import ViewerAnalyticsWorkflowResultsSlice from './actions/ViewerScreen/ViewerAnalyticsWorkflowResultsSlice';
import GetViewerWorkflowCountSlice from './actions/ViewerScreen/GetViewerWorkflowCountSlice';
import GetViewerHideColumns from './actions/HideColumns/GetViewerHideColumns';
import PostViewerHideColumns from './actions/HideColumns/PostViewerHideColumns';
import getPriceMemoEmailListSlice from './actions/SendEmail/GetPriceMemoEmail';
import getCpsMemberEmailListSlice from './actions/SendEmail/GetCpsMemberEmail';
import CMUploadedViewSlice from './actions/ContractMaintenance/CMUploadedView';
import MultipleRejectSlice from './actions/PriceMemo/RejectMultiple';
import SubmitUploadSlice from './actions/ContractMaintenance/SubmitUpload';
import PriceMemoMaintenanceSlice from './actions/PriceMemoMaintenance';
import SavePMMaintenanceSlice from './actions/PriceMemoMaintenance/SavePriceMemo';
import PublishPriceMemoSlice from './actions/PriceMemoMaintenance/PublishPriceMemo';
import getAuditLogSlice from './actions/GetAuditLogs';
import getAutoTargetReviewSlice from './actions/ContractMaintenance/GetAutoTargetReview';
import DeletePriceMemoSlice from './actions/PriceMemoMaintenance/DeletePriceMemo';
import DashboardMetricsCD from './actions/DashboardMetricsCD';
import QuotaMaintenanceSlice from './actions/QuotaMaintenance';
import SaveQuotaSlice from './actions/QuotaMaintenance/SaveQuota'; 
import SavedColumnSlice from './actions/QuotaMaintenance/SavedColumns';
import CalculateQuotaSlice from './actions/QuotaMaintenance/CalculateQuota';

import GMPActionDashboardSlice from './actions/GMP/GMPActionDashboardSlice';
import GMPAnalyticsWorkflowResultsSlice from './actions/GMP/GMPAnalyticsWorkflowResultsSlice';
import GMPSendToS4Slice from './actions/GMP/GMPSendToS4Slice';
import GMPRejectWorkflowSlice from './actions/GMP/GMPRejectWorkflowSlice';
import GMPSendForApprovalSlice from './actions/GMP/GMPSendForApprovalSlice';
import GMPResubmitWorkflowSlice from './actions/GMP/GMPResubmitWorkflowSlice';
import GMPEditApproversWorkflowSlice from './actions/GMP/GMPEditApproversWorkflowSlice';
import GMPClosedWorkFlowItemsSlice from './actions/GMP/GMPClosedWorkFlowItemsSlice';
import GMPOutboundSyncSlice from './actions/GMP/GMPOutboundSyncSlice';
import GMPPostHideColumns from './actions/GMP/GMPPostHideColumns';
import GMPGetHideColumns from './actions/GMP/GMPGetHideColumns';
import GetContractHideColumnSlice from './actions/HideCDColumn/GetContractHideColumns';
import PostContractHideColumnSlice from './actions/HideCDColumn/PostContractHideColumns';
import EditSisPriceMemoSlice from './actions/EditSisPriceMemo';
import GetLeadTimePIRSlice from './actions/GetLeadTimePIRSlice';
import TotalApproverListSlice from './actions/TotalApproverListSlice';
import getContractFilterDataSlice from './actions/Contracts/GetContractFilter';
import RejectToInitiatorSlice from './actions/RejectToInitiatorSlice';
import CreateTicketOutbountSlice from './actions/CreateTicketOutbountSlice';
import contractMaintenanceSlice from './actions/ContractMaintenance';
import postNewContractDataSlice from './actions/ContractMaintenance/NewContract';
import RecallSlice from './actions/LTPlanner/RecallSlice';
import RecallGMPSlice from './actions/LTPlanner/RecallGMPSlice';
import AddExtraApproversSlice from './actions/LTApprover/AddExtraApproversSlice';
import postSaveContractSlice from './actions/ContractMaintenance/SaveContracts';
import putDeleteContractSlice from './actions/ContractMaintenance/DeleteContracts';
import postUpdateContractDataSlice from './actions/ContractMaintenance/UpdateContract';
import addUpdateContractDataSlice from './actions/ContractMaintenance/AddContracts';
import postSubmitContractSlice from './actions/ContractMaintenance/SubmitContractMaintenance';
import contractReportingSlice from './actions/ContractMaintenance/ContractReporting';
import duplicateContractSlice from './actions/ContractMaintenance/DuplicateContracts';
import selectionSlice from './actions/SupportTicket/selectionSlice';
import tabSlice from './actions/SupportTicket/tabSlice';
import submitTicketSlice from './actions/SupportTicket/SubmitTicket';
import updateTargetValueSlice from './actions/ContractMaintenance/UpdateTargetValue';
import LTSupportTicketSlice from './actions/LTPlanner/LTSupportTicketSlice';
import GetLTSummaryDataSlice from './actions/LTPlanner/GetLTSummaryDataSlice';
import PostResolveLTTicketSummarySlice from './actions/LTPlanner/PostResolveLTTicketSummarySlice';
import targetValueReportSlice from './actions/ContractMaintenance/TargetValueReports';
import unmappedPlantSlice from './actions/PriceMemo/UnmappedPlants';
import saveUnmappedPlantSlice from './actions/PriceMemo/SaveUnmappedPlants';
import getMetricsDataSlice from './actions/DashboardMetricsCD';
import NewVariantSlice from './actions/VariantView/NewVariantSlice';
import GetVariantsListSlice from './actions/VariantView/GetVariantsListSlice';
import DeleteVariantSlice from './actions/VariantView/DeleteVariantSlice';
import GetShareUserSlice from './actions/VariantView/GetShareUserSlice';
import PostShareVariantSlice from './actions/VariantView/PostShareVariantSlice';
import EditVariantSlice from './actions/VariantView/EditVariantSlice';
import priceMemoArchiveSlice from './actions/PriceMemo/Archive';
import GetArchiveRecordsSlice from './actions/PriceMemo/GetArchive';
import postUndoArchiveSlice from './actions/PriceMemo/UndoArchive';
import getIISimulationDataSlice from './actions/InventoryImpactSimulation';

export const store = configureStore({
  reducer: {
    counter: counterSlice,
    apiData: apiSlice,
    dashboardDetails: dashboardTitle,
    userAuthorization: userAuthorization,
    userCardType: userTypeSlice,
    procurementDivisionType: procurementDivisionType,
    materialData: materialData,
    piceMemoData: PriceMemoSlice,
    dataErrors: DataErrorSlice,
    moveDataError: moveToDataErrorSlice,
    movedToContract: moveToContractSlice,
    adminScheduler: adminSchedulerSlice,
    saveLtJobs: saveAndRunSlide,
    getAllScheduledJobs: getAllScheduledJobsSlice,
    getJobRunDetails: getJobRunDetailSlice,
    getContractsData: contractSlice,
    resolve: resolveSlice,
    saveContracts: saveContractSlice,
    sendErrorEmail: sendErrorSlice,
    ActionDashboardSlice: ActionDashboardSlice,
    AnalyticsWorkflowResultsSlice: AnalyticsWorkflowResultsSlice,
    SendToS4MaterialsSlice: SendToS4MaterialsSlice,
    RejectWorkflowSlice: RejectWorkflowSlice,
    SendForApprovalSlice: SendForApprovalSlice,
    ReassignToOthersSlice: ReassignToOthersSlice,
    ResubmitWorkflowSlice: ResubmitWorkflowSlice,
    EditApproversWorkflowSlice: EditApproversWorkflowSlice,
    LTPlannerMaterialDropdownDataSlice: LTPlannerMaterialDropdownDataSlice,
    GetAllUsers: GetAllUsers,
    SearchLTPlannerMaterialSlice: SearchLTPlannerMaterialSlice,
    SaveLTPlannerMaterialSlice: SaveLTPlannerMaterialSlice,
    UpdateLTPlannerEditSlice: UpdateLTPlannerEditSlice,
    deleteContracts: deleteContractSlice,
    ParamConfigDropdownDataSlice: ParamConfigDropdownDataSlice,
    ParamConfigSearchMaterialSlice: ParamConfigSearchMaterialSlice,
    ParamConfigSaveSlice: ParamConfigSaveSlice,
    ParamConfigUpdateSlice: ParamConfigUpdateSlice,
    GetApproverResultsSlice: GetApproverResultsSlice,
    RejectPlannerByApproverSlice: RejectPlannerByApproverSlice,
    SendToNextLevelSlice: SendToNextLevelSlice,
    ViewAllLineItemsDataSlice: ViewAllLineItemsDataSlice,
    ltJobCancelled: jobCancelledSlice,
    GetWorkflowCountSlice: GetWorkflowCountSlice,
    getAllSourcePriceMemo: getAllSourcePriceMemoDataSlice,
    undoDataErr: undoDataErrorSlice,
    PowerBIMaterialDetailsSlice: PowerBIMaterialDetailsSlice,
    PowerBIActionDashboardSlice: PowerBIActionDashboardSlice,
    GetHeaderRolesSlice: GetHeaderRolesSlice,
    OutboundResyncSlice: OutboundResyncSlice,
    OutboundDataTableSlice: OutboundDataTableSlice,
    OutboundResolvedSlice: OutboundResolvedSlice,
    submitContracts: submitContractSlice,
    getJobInputDetail: getJobInputSlice,
    GetAdminHideColumns: GetAdminHideColumns,
    GetApproverHideColumns: GetApproverHideColumns,
    GetPlannerHideColumns: GetPlannerHideColumns,
    PostAdminHideColumns: PostAdminHideColumns,
    PostApproverHideColumns: PostApproverHideColumns,
    PostPlannerHideColumns: PostPlannerHideColumns,
    ResubmitSlice: ResubmitSlice,
    GraphPercentile: GraphPercentile,
    OutboundDataResyncPostAPI: OutboundDataResyncPostAPI,
    OutboundDataSyncPlanner: OutboundDataSyncPlanner,
    GetPowerBIReportsSlice: GetPowerBIReportsSlice,
    editJobDetailSlice: editJobDetailSlice,
    fetchPriceMemoReports: fetchPriceMemoReportSlice,
    fetchContractReports: fetchContractReportSlice,
    reOpenContract: reOpenContractSlice,
    ViewerAnalyticsWorkflowResultsSlice: ViewerAnalyticsWorkflowResultsSlice,
    GetViewerWorkflowCountSlice: GetViewerWorkflowCountSlice,
    GetViewerHideColumns: GetViewerHideColumns,
    PostViewerHideColumns: PostViewerHideColumns,
    GMPActionDashboardSlice: GMPActionDashboardSlice,
    GMPAnalyticsWorkflowResultsSlice: GMPAnalyticsWorkflowResultsSlice,
    GMPSendToS4Slice: GMPSendToS4Slice,
    GMPRejectWorkflowSlice: GMPRejectWorkflowSlice,
    GMPSendForApprovalSlice: GMPSendForApprovalSlice,
    GMPResubmitWorkflowSlice: GMPResubmitWorkflowSlice,
    GMPEditApproversWorkflowSlice: GMPEditApproversWorkflowSlice,
    GMPClosedWorkFlowItemsSlice: GMPClosedWorkFlowItemsSlice,
    GMPOutboundSyncSlice: GMPOutboundSyncSlice,
    GMPPostHideColumns: GMPPostHideColumns,
    GMPGetHideColumns: GMPGetHideColumns,
    getContractHidedColumn: GetContractHideColumnSlice,
    postContractHidedColumn: PostContractHideColumnSlice,
    editSisPriceMemo: EditSisPriceMemoSlice,
    getPriceMemoEmailList: getPriceMemoEmailListSlice,
    getCpsMemberEmailList: getCpsMemberEmailListSlice,
    GetLeadTimePIRSlice: GetLeadTimePIRSlice,
    TotalApproverListSlice: TotalApproverListSlice,
    getContractFilterDataSlice: getContractFilterDataSlice,
    RejectToInitiatorSlice: RejectToInitiatorSlice,
    CreateTicketOutbountSlice: CreateTicketOutbountSlice,
    contractMaintenanceSlice: contractMaintenanceSlice,
    postNewContractDataSlice: postNewContractDataSlice,
    RecallSlice: RecallSlice,
    AddExtraApproversSlice: AddExtraApproversSlice,
    RecallGMPSlice: RecallGMPSlice,
    postSaveContractSlice: postSaveContractSlice,
    putDeleteContractSlice: putDeleteContractSlice,
    postUpdateContractDataSlice: postUpdateContractDataSlice,
    addUpdateContractDataSlice: addUpdateContractDataSlice,
    postSubmitContractSlice: postSubmitContractSlice,
    contractReportingSlice: contractReportingSlice,
    duplicateContractSlice: duplicateContractSlice,
    selectionSlice: selectionSlice,
    GetAllGMPUsers: GetAllGMPUsers,
    tabSlice: tabSlice,
    submitTicketSlice: submitTicketSlice,
    updateTargetValueSlice: updateTargetValueSlice,
    LTSupportTicketSlice: LTSupportTicketSlice,
    GetLTSummaryDataSlice: GetLTSummaryDataSlice,
    PostResolveLTTicketSummarySlice: PostResolveLTTicketSummarySlice,
    targetValueReportSlice: targetValueReportSlice,
    unmappedPlantSlice: unmappedPlantSlice,
    saveUnmappedPlantSlice: saveUnmappedPlantSlice,
    getMetricsDataSlice: getMetricsDataSlice,
    NewVariantSlice: NewVariantSlice,
    GetVariantsListSlice: GetVariantsListSlice,
    DeleteVariantSlice: DeleteVariantSlice,
    GetShareUserSlice: GetShareUserSlice,
    PostShareVariantSlice: PostShareVariantSlice,
    EditVariantSlice: EditVariantSlice,
    priceMemoArchiveSlice: priceMemoArchiveSlice,
    GetArchiveRecordsSlice: GetArchiveRecordsSlice,
    postUndoArchiveSlice: postUndoArchiveSlice,
    CMUploadedViewSlice: CMUploadedViewSlice,
    MultipleRejectSlice: MultipleRejectSlice,
    SubmitUploadSlice: SubmitUploadSlice,
    PriceMemoMaintenanceSlice: PriceMemoMaintenanceSlice,
    SavePMMaintenance: SavePMMaintenanceSlice,
    publishPriceMemoSlice: PublishPriceMemoSlice,
    getAuditLogSlice: getAuditLogSlice,
    getAutoTargetReviewSlice: getAutoTargetReviewSlice,
    getIISimulationDataSlice: getIISimulationDataSlice,
    deletePriceMemoSlice: DeletePriceMemoSlice,
    DashboardMetricsCD: DashboardMetricsCD,
    QuotaMaintenanceSlice: QuotaMaintenanceSlice,
    SaveQuotaSlice: SaveQuotaSlice, 
    SavedColumnSlice: SavedColumnSlice,
    CalculateQuotaSlice: CalculateQuotaSlice,
  },
})